import log from 'loglevel';
const logger = log.getLogger('table-client');
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- used in eval
import { FieldType } from './models.js';
export class UpdateParser {
    fieldDescriptors;
    parser;
    decoder = new TextDecoder('utf-8');
    constructor(fieldDescriptors) {
        this.fieldDescriptors = fieldDescriptors;
        if (fieldDescriptors)
            this.descriptors = fieldDescriptors;
        this.decoder; // use it so it doesn't tree-shake
    }
    get descriptors() {
        return this.fieldDescriptors;
    }
    set descriptors(descs) {
        this.fieldDescriptors = descs;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars -- used in eval
        const parsedValuesMap = new Map(descs.filter((x) => x.name && x.parsedValues).map((x) => [x.name, x.parsedValues]));
        let body = `
        let view;
        if (payload instanceof ArrayBuffer) {
            view = new DataView(payload);
        } else if (payload instanceof DataView) {
            view = payload;
        } else {
            view = new DataView(payload.buffer, payload.byteOffset, payload.byteLength);
        }

        let offset = 0;
        let len, size; // numbers
        let val;
        let parsedValues;
        
        const acc = cache || {};


        `;
        for (const field of descs) {
            const { size, type, name, parsedValues } = field;
            // logger.log('parsing field', name, 'of value', acc['${name}'], 'of type', type, 'and size', size, 'at offset', offset);
            body += `
                    
            
                    // *** parsing ${name} of type ${type}
                    size = ${size};
            `;
            if (parsedValues) {
                body += `
                parsedValues = parsedValuesMap.get('${name}');
                `;
            }
            switch (type) {
                case FieldType.String:
                case FieldType.Token:
                case FieldType.Symbol:
                case FieldType.CacheKey: {
                    body += `
                    len = view.getUint16(offset, true); offset += 2;
                    // logger.debug('len is', len, 'for field', name, 'with mask', mask);

                    if (len === 0) {
                        acc['${name}'] = '';
                    } else {
                        acc['${name}'] = this.decoder.decode(new DataView(view.buffer, view.byteOffset + offset, len));
                    }
                        
                    // for flat strings, don't replace size with len
                    // if (type == FieldType.String || type == FieldType.Token)
                    size = len; // dynamic length string
                    
                `;
                    break;
                }
                case FieldType.TimeStamp: {
                    body += `
                    acc['${name}'] = view.getFloat64(offset, true); // new Date(
                    `;
                    break;
                }
                // case FieldType.Sequence:
                // case FieldType.Volume:
                // case FieldType.Float: {
                //     if (size == 8)
                //         acc['${name}'] = view.getFloat64(offset, true);
                //     else if (size == 4)
                //         acc['${name}'] = view.getFloat32(offset, true);
                //     else
                //         throw new Error("Parser error: Floats may only be 4 or 8 bytes.")
                // }
                case FieldType.Price:
                case FieldType.Capital: {
                    body += `
                    acc['${name}'] = view.getFloat64(offset, true);
                    `;
                    break;
                }
                case FieldType.Sequence:
                case FieldType.Volume:
                case FieldType.Float:
                case FieldType.Integral:
                case FieldType.Count:
                case FieldType.Context:
                case FieldType.Quantity:
                case FieldType.Boolean:
                case FieldType.Bitmask:
                case FieldType.Char:
                case FieldType.Index: {
                    // let val: number | string;
                    // if (size === 1)
                    //     val = view.getInt8(offset);
                    // else if (size === 2)
                    //     val = view.getInt16(offset, true);
                    // else if (size == 4)
                    //     val = view.getInt32(offset, true);
                    // else if (size == 8)
                    //     null; // todo // val = view.getUint32(fieldOffset, true)*Math.pow(2, 32) + view.getUint32(fieldOffset + 4, true);
                    body += `
                    val = view.getFloat64(offset, true);
                    `;
                    if (type === FieldType.Char) {
                        body += `
                    val = String.fromCharCode(val);
                        `;
                    }
                    if (type === FieldType.Boolean) {
                        body += `
                        acc['${name}'] = !!val;
                        `;
                    }
                    else if (parsedValues) {
                        body += `
                        acc['${name}'] = parsedValues[val];
                        if (acc['${name}'] === undefined) acc['${name}'] = parsedValues[\`'\${val}'\`]; // hack bugfix for now
                        `;
                    }
                    else {
                        body += `
                        acc['${name}'] = val;
                        `;
                    }
                    body += `
                        size = 8;
                    `;
                    break;
                }
                case FieldType.Date: {
                    // todo
                    body += `
                    const val = view.getInt16(offset, true);
                    `;
                    break;
                }
                default: {
                    logger.warn('ignoring field', name, 'of unknown type', type, 'and size', size);
                }
            }
            // logger.log('got field', name, 'of value', acc['${name}'], 'of type', type, 'and size', size, 'at offset', offset);
            body += `
            offset += size;
            `;
            // pmask &= ~mask;
        }
        body += `
        return acc;
        `;
        this.parser = new Function(['parsedValuesMap', 'payload', 'cache'], body).bind(this, parsedValuesMap);
    }
    parse(payload, fields, cache) {
        if (fields !== this.descriptors)
            this.descriptors = fields;
        return this.parser(payload, cache);
    }
}
//# sourceMappingURL=snapshotParser.js.map